<template>
  <div class="step-wrapper">
    <div class="step-wrapper-subject wil-was-here"><strong>step 1 | add text</strong></div>
    <div class="step-wrapper-description mt-4 mb-4">For vertical text or text with separate lines, press enter after each letter or line.</div>

    <div v-if="!typeIntention" v-on:click="enableInput" style="text-transform: uppercase; font-size: 16px; background-color: #f5f5f5; color: red;" class="p-4">
      <strong>
        TYPE TEXT HERE
      </strong>
    </div>

    <b-form-textarea v-if="typeIntention"
                     id="stencilease-text"
                     v-model="stencileaseText"
                     placeholder="Enter something"
                     :rows="3"
                     :max-rows="6"
                     class="mt-4 mb-2"
                     @change.native="changeStencilText"
                     @keyup.native="changeStencilText">
    </b-form-textarea>

    <p v-if="invalid" class="alert alert-danger">
    <span style="left: 5px; width: 1.5em; position: absolute;">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-corner-left-up"><polyline points="14 9 9 4 4 9"></polyline><path d="M20 20h-7a4 4 0 0 1-4-4V4"></path></svg>
    </span>
    Please enter the stencil's text before proceeding
    </p>

    <b-button variant="default" class="go-next" v-on:click="goNext">next</b-button>
  </div>
</template>

<script>
import jQuery from 'jquery'

export default {
  components: {
    jQuery
  },
  data() {
    return {
      stencileaseText: "",
      interacted: false,
      typeIntention: false
    }
  },
  computed: {
    invalid: function (){
      return this.interacted && (this.stencileaseText == "");
    }
  },
  methods: {
    enableInput: function(e) {
      this.typeIntention = true;
      setTimeout(
        function() { document.getElementById("stencilease-text").focus() },
        50
      );
    },
    changeStencilText(evt) {
      this.$store.dispatch('product/SET_TEXT', evt.target.value)
    },
    goNext(evt) {
      this.interacted = true;

      if (this.stencileaseText != "") {
        this.$store.dispatch('product/SET_OLDTAB', 0)
        this.$store.dispatch('product/SET_ACTIVETAB', 0)
        this.$store.dispatch('product/SET_ACTIVETAB', 1)
      } else {
        jQuery('#stencilease-text').focus();
      }
    }
  }
}
</script>
